export default __webpack_public_path__ + "static/media/unlock.ccba6cd5.svg";